// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_qcb","cls2":"ProfilePdfPackCard-cls2_2gR ProfilePdfPackCard-cls1_qcb"};